import * as d3 from "d3";
var is_first_time=true
export function setupSvg(svg, zoom_polite,fit_tree=true,coordinates) {
  setupZoom()
  function setupZoom() {
    var view = svg.querySelector('.view');
    var zoom;
    
    if (!fit_tree) {
      // For the download case, constrain scaling to 1 and allow only translation
      zoom = d3.zoom()
        .scaleExtent([1, 1]) // Lock the scale to 1 (no zoom in/out)
        .on("zoom", zoomed);
    } else {
      // Normal case: allow zooming with default behavior
      zoom = d3.zoom()
        .on("zoom", zoomed);
    }

    d3.select(svg).call(zoom)
    svg.__zoomObj = zoom

    if (zoom_polite) zoom.filter(zoomFilter)

    function zoomed(e) {
      if(!fit_tree){
        let  { x, y } = e.transform;
        const scale = 1; // Set the scale value to 1
        d3.select(view).attr("transform", `scale(${scale})`);
        d3.select(view).attr("transform", `translate(${coordinates.x_off+200},${coordinates.y_off+200})`);

      }
      else{
            d3.select(view).attr("transform", e.transform);
    }
    }

    function zoomFilter(e) {
      if (e.type === "wheel" && !e.ctrlKey) return false
      else if (e.touches && e.touches.length < 2) return false
      else return true
    }
  }
}

function positionTree({t, svg, transition_time=2000,fit_tree}) {
  const zoom = svg.__zoomObj

  if(!fit_tree){
    d3.select(svg)
  d3.select(svg).transition().duration(transition_time || 0).delay(transition_time ? 100 : 0)  // delay 100 because of weird error of undefined something in d3 zoom
    .call(zoom.transform, d3.zoomIdentity.translate(t.x, t.y));
  }
  else{
    
      d3.select(svg).transition().duration(transition_time || 0).delay(transition_time ? 100 : 0)  // delay 100 because of weird error of undefined something in d3 zoom
        .call(zoom.transform, d3.zoomIdentity.scale(t.k).translate(t.x, t.y))
  }
}

export function treeFit({svg, svg_dim, tree_dim, with_transition, transition_time,framePadding}, fit_tree=true) {
  const t = calculateTreeFit(svg_dim, tree_dim,framePadding,fit_tree);
  positionTree({t, svg, with_transition, transition_time,fit_tree})
}

// export function calculateTreeFit(svg_dim, tree_dim) {
//   let k = Math.min(svg_dim.width / tree_dim.width, svg_dim.height / tree_dim.height),
//     x = tree_dim.x_off + (svg_dim.width - tree_dim.width*k)/k/2,
//     y = tree_dim.y_off + (svg_dim.height - tree_dim.height*k)/k/2
//   console.log(k)
//   if (k>1) {x*=k;y*=k;k=1;}
//   return {k,x,y}
// }

export function calculateTreeFit(svg_dim, tree_dim, framePadding = {left: 0, right: 0, top: 0, bottom: 0},fit_tree=true) {
  // Reduce available SVG dimensions by the frame's padding
  let availableWidth = svg_dim.width - framePadding.left - framePadding.right;
  let availableHeight = svg_dim.height - framePadding.top - framePadding.bottom;
  let k;
  if (!fit_tree){
     k=1;
  }
  else{
    // Calculate the scaling factor, now based on the reduced available width/height
    k = Math.min(availableWidth / tree_dim.width, availableHeight / tree_dim.height);
  }
  // Calculate x and y offsets for centering, considering the frame padding
  let x = tree_dim.x_off + (availableWidth - tree_dim.width * k) / k / 2 + framePadding.left;
  let y = tree_dim.y_off + (availableHeight - tree_dim.height * k) / k / 2 + framePadding.top;

  if(fit_tree){
    if (k > 1) {
      x *= k;   
      y *= k;
      k = 1;
    }
}

  return { k, x, y };
}


export function mainToMiddle({datum, svg, svg_dim, scale, transition_time}) {
  const k = scale || 1, x = svg_dim.width/2-datum.x*k, y = svg_dim.height/2-datum.y,
    t = {k, x: x/k, y: y/k}
  positionTree({t, svg, with_transition: true, transition_time, fit_tree:true})
}
